module.exports = __webpack_public_path__ + "img/ic_download_ios.c0adc36f.png";